import {ContactEmail, User} from "models"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/inputs/button"
import classNames from "classnames"
import {digg} from "diggerize"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import Input from "components/inputs/input"
import MainCard from "components/main-card"
import memo from "set-state-compare/build/memo"
import React from "react"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
/**
 * @typedef {object} ComponentsUsersForgotPasswordProps
 * @property {unknown} className
 */

/**
 * @typedef {object} ComponentsUsersForgotPasswordState
 * @property {boolean} requestSent
 */

/**
 * @extends {ShapeComponent<ComponentsUsersForgotPasswordProps, ComponentsUsersForgotPasswordState>}
 */
class ComponentsUsersForgotPassword extends ShapeComponent {
  /** @type {ComponentsUsersForgotPasswordState} */
  state = {
    requestSent: false
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.users.forgot_password"})

    this.t = t
  }

  render() {
    const {t} = this.tt
    const {className, ...restProps} = this.props

    return (
      <MainCard
        className={classNames("components--users--forgot-password", className)}
        header={t(".reset_password")}
        subHeader={t(".write_your_email_and_follow_instructions")}
        {...restProps}
      >
        {this.s.requestSent &&
          <div className="we-have-sent-an-email-container">
            {t(".we_have_sent_an_email_about_how_to_reset_your_password")}
          </div>
        }
        {!this.s.requestSent &&
          <form onSubmit={this.tt.onSubmit}>
            <Input className="user-email-input" icon="at" label={ContactEmail.humanAttributeName("email")} name="email" />
            <Button label={t(".send_instructions")} primary style={{width: "100%"}} />
          </form>
        }
      </MainCard>
    )
  }

  onSubmit = async (e) => {
    e.preventDefault()

    const form = digg(e, "target")
    const formData = new FormData(form)

    try {
      await User.requestNewPassword(formData)
      this.setState({requestSent: true})
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}

export default memo(shapeComponent(ComponentsUsersForgotPassword))
